module.exports = __webpack_public_path__ + "img/ownerTypes.7cbf18dc.svg";